import React, { useState, useRef, useEffect } from "react";
import { FaFileAlt } from "react-icons/fa";
import "../../styles/common/index.css"; // Common styles (PageLayout, ActionBar, FilterForm)
import "./MISReport.css"; // Page-specific styles

const MISReport = () => {
  const [selectedReport, setSelectedReport] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownId = useRef("mis-report-dropdown-" + Math.random().toString(36).substr(2, 9));

  // Listen for other dropdowns opening and close this one
  useEffect(() => {
    const handleOtherDropdownOpen = (event) => {
      if (event.detail !== dropdownId.current && isDropdownOpen) {
        setIsDropdownOpen(false);
      }
    };

    window.addEventListener("dropdown:open", handleOtherDropdownOpen);
    return () => {
      window.removeEventListener("dropdown:open", handleOtherDropdownOpen);
    };
  }, [isDropdownOpen]);

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Use setTimeout to avoid immediate closure
    setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleOptionSelect = (option, e) => {
    e?.stopPropagation();
    if (option !== "SELECT") {
      setSelectedReport(option);
    } else {
      setSelectedReport("");
    }
    setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const willBeOpen = !isDropdownOpen;
    setIsDropdownOpen(willBeOpen);
    
    // Dispatch event to close other dropdowns
    if (willBeOpen) {
      window.dispatchEvent(new CustomEvent("dropdown:open", { detail: dropdownId.current }));
    }
  };

  const handleGenerateReport = () => {
    if (!selectedReport) {
      alert("Please select a report");
      return;
    }
    // TODO: Implement report generation functionality
    console.log("Generating Report:", selectedReport);
    alert(`Generating ${selectedReport}`);
  };

  const reportOptions = [
    "SELECT",
    "COLLECTION (AFTER 10 DPD) - RECOVERY",
    "COLLECTION (ON BEFORE DUE DATE) - PRE-COLLECTION",
    "COLLECTION (UPTO 10 DPD) - COLLECTION",
    "COLLECTION : BRANCH WISE BY PAYMENT DATE",
    "COLLECTION : BRANCH WISE BY REPAY DATE",
    "COLLECTION : COLLECTION EXECUTIVE BY PAYMENT DATE",
    "COLLECTION : COLLECTION EXECUTIVE BY REPAY DATE",
    "COLLECTION : SANCTION EXECUTIVE BY PAYMENT DATE",
    "COLLECTION : SANCTION EXECUTIVE BY REPAY DATE",
    "COLLECTION BUCKET-WISE REPORT (AMOUNT)",
    "COLLECTION BUCKET-WISE REPORT (CASES)",
    "COLLECTION CALL FOLLOWUP STATUS WISE",
    "COLLECTION CALL FOLLOWUP WITH TIME",
    "HOURLY DISBURSAL REPORT",
    "HOURLY STATUS WISE REPORT",
    "LEAD CONVERSION REPORT (FRESH)",
    "LEAD CONVERSION REPORT (REPEAT)",
  ];

  return (
    <div className="page-wrapper mis-report-page">
      {/* Page Header */}
      <div className="page-header-section">
        <div className="page-title-section">
          <h1 className="mis-report-page-title">MIS Report</h1>
        </div>
      </div>

      {/* MIS Report Form Section */}
      <div className="mis-report-form-section">
        <div className="mis-report-form-container">
          <div className="mis-report-form-row">
            {/* Report Selection Dropdown */}
            <div className="mis-report-form-field">
              <div className={`custom-dropdown-wrapper ${isDropdownOpen ? 'active' : ''}`} ref={dropdownRef}>
                <div
                  className="custom-dropdown-trigger"
                  onClick={toggleDropdown}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <span className={!selectedReport ? "placeholder" : ""}>
                    {selectedReport || "SELECT"}
                  </span>
                  <span className="dropdown-arrow">▼</span>
                </div>
                {isDropdownOpen && (
                  <div className="custom-dropdown-menu">
                    {reportOptions.map((option, index) => (
                      <div
                        key={index}
                        className={`custom-dropdown-option ${
                          selectedReport === option || (!selectedReport && option === "SELECT")
                            ? "selected"
                            : ""
                        }`}
                        onClick={(e) => handleOptionSelect(option, e)}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Generate Report Button */}
            <div className="mis-report-button-field">
              <button
                className="mis-report-submit-btn"
                onClick={handleGenerateReport}
                disabled={!selectedReport}
              >
                <FaFileAlt className="mis-report-icon" />
                GENERATE REPORT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MISReport;

